// extracted by mini-css-extract-plugin
export default {"direction-header":"_2nuYksxt7W","directionHeader":"_2nuYksxt7W","policy-source":"_39JAvcWZlc","policySource":"_39JAvcWZlc"};
    if(module.hot) {
      // 1627035575404
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  